var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('div',{staticClass:"animated",class:_vm.buttonClasses,attrs:{"id":"toTop"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.sendTop($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }